<template>
  <section v-show="records && (records.length > 0)">
    <h2 class="mx0 my1">Fundamentação Legal</h2>
    <div class="my1" v-for="(record, index) in leis" :key="index">
      <h3 class="mx0 my1">{{record.LEI}}</h3>
      <div class="h3" v-for="(item, index) in record.DESCRICOES" :key="index">
        <p v-for="(linha, index) in item.LINHAS" :key="index">
          {{linha.CONTEUDO}}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
var componentDefinition = {
  props: ['records'],
  computed: {
    leis: function () {
      var leis = []
      if (this.records) {
        var idlei = 0
        this.records.map(record => {
          if (record.IDLEI !== idlei) {
            leis.push({
              LEI: record.LEI,
              DESCRICOES: []
            })
          }
          idlei = record.IDLEI
          var lei = leis[leis.length - 1]
          lei.DESCRICOES.push({
            DESCRICAO: record.DESCRICAO,
            LINHAS: record.LINHAS
          })
        })
      }
      return leis
    }
  }
}
export default componentDefinition
</script>
